import { LocalStorage } from "./services/localStorage";
import { MessageBus } from "./services/messageBus";
import { App } from "./services/app";
import { iframeHandlers, msgBusHandlers } from "./handlers";
import { getMessageBus } from "./common/utils";
import "./css/main.css";
import { Analytics } from "./services/analytics";
import { GtpService } from "./services/gtpService";
import { StateManager } from "./services/stateManager";
import { LocalDev } from "./services/localDev";

declare global {
  interface Window {
    WH: any;
    __tracking_calls: any;
    AnalyticsTactical: any;
  }
}

const storage = new LocalStorage();

const app = new App({
  msgBus: new MessageBus(getMessageBus()),
  stateMngr: new StateManager(storage),
  gtpService: new GtpService(),
  analytics: new Analytics(),
  iframeHandlers,
  msgBusHandlers,
});

const localDev = new LocalDev();
localDev.init();
app.init();
